function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#CB3327;}\n\t.st1{fill:#990000;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#FF232B;}\n\t.st4{fill:url(#SVGID_00000107557439850681255920000011353480867280078757_);}\n\t.st5{fill:url(#SVGID_00000052790665465226341430000012461229727242283682_);}\n\t.st6{fill:url(#SVGID_00000079449339901005093490000004754673280803768235_);}\n\t.st7{fill:#CCCCCC;}\n\t.st8{fill:#818181;}\n\t.st9{fill:url(#SVGID_00000070107768297331080210000007850860115419189174_);}\n\t.st10{fill:url(#SVGID_00000167375717812391381420000007700986242577149115_);}\n\t.st11{fill:url(#SVGID_00000031910675754803485670000001285584478776793516_);}\n\t.st12{fill:url(#SVGID_00000024712739773796264950000000373698950956559022_);}\n\t.st13{fill:url(#SVGID_00000036210242745275100550000000781605975311789199_);}\n\t.st14{fill:url(#SVGID_00000170256547682002828070000014840211195157661620_);}\n\t.st15{fill:url(#SVGID_00000090992961441237140330000005917469523722711976_);}\n\t.st16{fill:url(#SVGID_00000147908348094317129480000016943711304183121819_);}\n\t.st17{fill:url(#SVGID_00000029754655212750461950000015321357268950187924_);}\n\t.st18{fill:#6B0000;}\n\t.st19{fill:#A2A2A2;}\n\t.st20{fill:#333333;}\n\t.st21{fill:url(#SVGID_00000016044295920991237820000015834822832490354577_);}\n\t.st22{fill:url(#SVGID_00000088830635475753481420000012040776085214328978_);}\n\t.st23{fill:url(#SVGID_00000103958200169995063940000005251474841838572727_);}\n\t.st24{fill:url(#SVGID_00000023268991756403285840000005488279948789057695_);}\n\t.st25{fill:#767676;}\n\t.st26{fill:url(#SVGID_00000121961096311409892260000016336984526331980730_);}\n\t.st27{fill:url(#SVGID_00000183958991241051701020000005787544420667388317_);}\n\t.st28{fill:url(#SVGID_00000097500018245763728240000002843386106058705570_);}\n\t.st29{fill:#FF6464;}\n\t.st30{fill:#EFEFEF;}\n\t.st31{fill:#FF4949;}\n\t.st32{fill:url(#SVGID_00000175321280172311495690000018199914204355610000_);}\n\t.st33{fill:url(#SVGID_00000152241466904200659880000003193320272805058485_);}\n\t.st34{fill:url(#SVGID_00000042733124840332281560000000109276685651384251_);}\n\t.st35{fill:url(#SVGID_00000026860649935283222390000004294755112218990011_);}\n\t.st36{fill:url(#SVGID_00000033347063885111329840000005551541122772502165_);}\n\t.st37{fill:url(#SVGID_00000159427826744974637980000001770843327652883899_);}\n\t.st38{fill:url(#SVGID_00000016756779100529828530000016995486556889816473_);}\n\t.st39{fill:url(#SVGID_00000071560048628281510420000012652351280415179451_);}\n\t.st40{fill:url(#SVGID_00000102515014414166827260000012410853990178939575_);}\n\t.st41{fill:url(#SVGID_00000179603872871986876940000018329102187732502415_);}\n\t.st42{fill:url(#SVGID_00000089561505489565614060000004829740148733213844_);}\n\t.st43{fill:url(#SVGID_00000087390979423930304410000016824377237498908605_);}\n\t.st44{fill:url(#SVGID_00000071558316948539239270000014382594926242492094_);}\n\t.st45{fill:url(#SVGID_00000122682665563057696670000002160929221814796981_);}\n\t.st46{fill:url(#SVGID_00000140009929597090300270000013125587684300011686_);}\n\t.st47{fill:url(#SVGID_00000047782987980818193520000008289711674165329336_);}\n\t.st48{fill:url(#SVGID_00000086667345530932563550000002718310960574483122_);}\n\t.st49{fill:url(#SVGID_00000029725285947440668780000003386685498872541093_);}\n\t.st50{fill:url(#SVGID_00000168802642188092984240000017267547755230267833_);}\n\t.st51{fill:url(#SVGID_00000183229475747288801700000015817729141307094719_);}\n\t.st52{fill:url(#SVGID_00000082326239622942748930000001306889377757095611_);}\n\t.st53{fill:url(#SVGID_00000075155265258212464810000016198144218791669145_);}\n\t.st54{fill:url(#SVGID_00000156556370466736720610000000839385423441650089_);}\n\t.st55{fill:url(#SVGID_00000172413912506604978750000003241293880915252148_);}\n\t.st56{fill:url(#SVGID_00000044143727438063671340000002689618581419685544_);}\n\t.st57{fill:url(#SVGID_00000078002671497857807590000009586472315277654940_);}\n\t.st58{fill:url(#SVGID_00000175315358570873712170000000025911592772724873_);}\n\t.st59{fill:url(#SVGID_00000098203153091324692510000013114346587015223727_);}\n\t.st60{fill:url(#SVGID_00000168079381965644570010000005693558207830643606_);}\n\t.st61{fill:url(#SVGID_00000140712391282884088610000018446153335435440318_);}\n\t.st62{fill:url(#SVGID_00000066505722679278941220000008102702742681191354_);}\n\t.st63{fill:url(#SVGID_00000090287494229304988070000005190020574663015859_);}\n\t.st64{fill:url(#SVGID_00000107575247784659857500000009799959422291031215_);}\n\t.st65{fill:url(#SVGID_00000181779315516720653200000010632881532313140646_);}\n\t.st66{fill:url(#SVGID_00000045579669944836296010000001846457555185511338_);}\n\t.st67{fill:url(#SVGID_00000017479762067306770780000014788061486035501486_);}\n\t.st68{fill:url(#SVGID_00000094595949457079874690000004635882988032380051_);}\n\t.st69{fill:url(#SVGID_00000117660602842871120810000014379889798334784928_);}\n\t.st70{fill:url(#SVGID_00000123405727543568872990000011654524235675119539_);}\n\t.st71{fill:url(#SVGID_00000121240404675592194540000006832396225237671353_);}\n\t.st72{fill:url(#SVGID_00000067918884900688392090000010686043420414298764_);}\n\t.st73{fill:url(#SVGID_00000013911910723603552290000007456864282322926250_);}\n\t.st74{fill:url(#SVGID_00000099640118071711430880000014734228521183291839_);}\n\t.st75{fill:url(#SVGID_00000037657667393550564380000002674806970827846541_);}\n\t.st76{fill:url(#SVGID_00000079460193999036790180000018061927223128622770_);}\n\t.st77{fill:url(#SVGID_00000181775520443121712200000004661463476676041125_);}\n\t.st78{fill:url(#SVGID_00000134945226951532385390000011282227598608838016_);}\n\t.st79{fill:url(#SVGID_00000050638224427873074680000013645528957496770485_);}\n\t.st80{fill:url(#SVGID_00000041269823086610038970000008985421122590939808_);}\n\t.st81{fill:url(#SVGID_00000020394368325349822070000011597219352534912703_);}\n\t.st82{fill:url(#SVGID_00000090994212402680941800000005002118664690410657_);}\n\t.st83{fill:url(#SVGID_00000017495537540283316120000015865675129624238226_);}\n\t.st84{fill:url(#SVGID_00000173140495910240593960000004380619902288460422_);}\n\t.st85{fill:url(#SVGID_00000011014503050687715320000013303862228610743707_);}\n\t.st86{fill:url(#SVGID_00000091716801769241875450000017740295781278548110_);}\n\t.st87{fill:url(#SVGID_00000034792998982063235110000011598486626052869506_);}\n\t.st88{fill:url(#SVGID_00000049939888801597868240000006964029727360791974_);}\n\t.st89{fill:url(#SVGID_00000047763348377706873920000000312761573154970032_);}\n\t.st90{fill:url(#SVGID_00000027594947859559618480000000507795252327571112_);}\n\t.st91{fill:url(#SVGID_00000047766519121837273160000010445982303070945975_);}\n\t.st92{fill:url(#SVGID_00000122686815025151906160000006364496372144670101_);}\n\t.st93{fill:url(#SVGID_00000005945260169638594040000006297541614636427942_);}\n\t.st94{fill:url(#SVGID_00000022533226882188256680000013110460772822467725_);}\n\t.st95{fill:url(#SVGID_00000039832411965651042670000002552788775209272231_);}\n\t.st96{fill:url(#SVGID_00000059294060736293280630000009109804628155535275_);}\n\t.st97{fill:#FFFFFF;fill-opacity:0.7098;}\n\t.st98{fill:url(#SVGID_00000019667814807490660960000007846839002705222548_);}\n\t.st99{fill:url(#SVGID_00000148619399460276054840000012645750193017832639_);}\n\t.st100{fill:url(#SVGID_00000169542484656438606740000014304932741057818288_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58.1,24.9h-7.4C50.2,18.9,58.6,18.9,58.1,24.9z M54.6,18.5c-4.9-0.2-6.5,4.1-6.1,8.5c-0.1,4.3,2.6,7,6.9,7H58 c0.8,0.1,0.4-1.3,0.5-1.7c0.2-0.9-2.9-0.3-3.3-0.4c-2.8,0.1-4.9-2.4-4.6-5h9.1c0.3,0,0.5-0.3,0.5-0.9 C60.6,22.1,58.8,18.4,54.6,18.5 M64.3,12.1c-0.4,0.1-1.7-0.3-1.7,0.5v21c-0.1,0.8,1.2,0.4,1.7,0.5c0.3,0,0.5-0.2,0.5-0.5v-21 C64.7,12.2,64.6,12.1,64.3,12.1 M77.4,18.9h-4.3v-3.4c0.1-0.8-1.3-0.4-1.7-0.5c-0.3,0-0.5,0.2-0.5,0.5c0.3,3.8-1,13.2,1.5,16.3 c1.2,1.7,2.9,2.4,4.8,2.3c0.7,0.1,0.4-1.2,0.5-1.6c0-0.5-0.4-0.5-0.8-0.5c-5-0.3-3.8-7.7-3.9-11.2h4.3c0.3,0,0.5-0.2,0.5-0.4 C77.8,19.9,78.1,18.8,77.4,18.9 M90.8,27.7c0.4,4.1-4.5,6.5-7.3,3.6c-1.8-1.6-1.8-8.1,0-9.6c1.5-1.7,4.6-1.7,6.1,0 C90.9,22.9,90.8,25.8,90.8,27.7z M86.4,18.5c-4.9-0.1-6.8,4.3-6.4,8.7c-0.1,4.1,2.3,7.2,6.4,7.2c4.9,0.1,6.8-4.3,6.4-8.7 C92.9,21.6,90.6,18.5,86.4,18.5 M102.8,18.8c-2.2,0-3.8,0.9-5,2.6c-0.1-0.4,0.4-2.7-0.5-2.6c-0.4,0.1-1.7-0.3-1.7,0.5v14.2 c-0.1,0.8,1.2,0.4,1.7,0.5c0.3,0,0.5-0.2,0.5-0.5c0.3-2.6-0.9-9.1,1.3-11c1.3-1.9,4.1-1.1,4.2-2C103.2,20.1,103.6,18.8,102.8,18.8  M116.1,27.7c0.4,4.1-4.6,6.5-7.3,3.6c-0.9-0.9-1.3-2.1-1.3-3.6c0-1.9-0.2-4.7,1.3-6c1.5-1.7,4.6-1.7,6.1,0 C116.3,22.9,116.1,25.8,116.1,27.7z M116.5,20.5c-2.1-2.6-7.3-2.6-9.4,0c-2.4,2.7-2.4,9.4,0,12c2.1,2.6,7.3,2.6,9.4,0 C118.9,29.8,118.9,23.1,116.5,20.5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "black_00000072258168729080144310000004404428194950671488_",
  d: "M44,7.4c-1.7-2.9-7.1,0.2-7.6,0.2 c-5.2-2.9-8.8,2-0.9,1.4c0.1,0.2-0.4,1.7-0.7,2c-1.8-0.7-3.2-1.6-4.2-2.2c0.1-3.4-5.5-5-4.2-8c-1.7,0.4-2.5,2.7-1.3,4 c0.3,0.4,1.4,1.1,1.8,2.4c-1.3-0.9-3.2-0.9-3.6,0c-0.8,1.2-2.8,2-3.7,2.7c-2.6-0.5-5.4,0.1-6.8,2c-1.1-0.4-1.8,0-2.2,0.7 c-0.7,0.4-1.9-0.1-2.4-1.1c-0.9-2,2-6.7-2.9-5.4c3.6,1.3-2.9,6,1.2,9.5c-0.6-0.1-1.2-0.1-1.7-0.2l0,0c-0.1,0-0.1,0-0.2,0 c0.8,1.3,0.8,2.2,2.3,2.7c0.5,1.2,1.4,2,2.8,2.4c-1,1.4-0.5,2.4-0.3,3.9c0.1,1.8-1.9,3-1.7,4.8c-0.1,4-4.4,3.2-3.8,5.2 c-2.2-0.2-5.1,5.4-1.5,4.8c0,0.1,0,0.1,0,0.2c0,0,0-0.1,0-0.1C4,40.2,6.9,40,8.1,39.1c0.3-0.6,0.2-1.9,0-2.6 c2.7,0.1-0.4-4.3,5-6.7c0.2,0.4,0.5,0.6,0.9,0.7c-0.3,1,1,2.5,1.9,1.5c0.7,1,1,0.6,1.7,0.2c0.8-0.2,2.4,0.5,2.6-0.8 c1.1-0.1,1.5-0.5,1.4-1.4c0.4,0.3,0.8,0.9,1.2,1.2c-0.2,0.6-1.7,0.2-1.2,1.2c-1.4,0.7-1.8,3.5,0.4,2.8c0.2,0.4,0.7,0.5,1.1,0.3 c0,0.1,0,0.1,0.1,0.1c-2.7,1.9-2.8,7,1.6,5.4c0.4,0.5,1.8,0.5,2.5,0.5c2.7-0.1,3.2-1.8,2.3-3.9c1.2-1.3-0.7-3.4,2.7-5.3 c1.2-0.9,0.6-1.2,0.6-2.3c1-1.3,2.6-2,3.4-3.7c0.6,3.2,2.2,2.5,0.8,6.1c0,0.1,0.2,0.7,0.3,0.9c-1.7,1.9,0.6,3.9,2.3,2.8 c2.6,1.1,3.3-1.3,1.9-3.1c0.9-1-0.3-1.5-0.7-2.3c-0.2-0.2-0.3-1.6,0.5-3c0.6-1.7-0.1-2.6,0.8-4.4c0.8-2.4-0.6-3.4-0.9-5.5 c-0.3-4.6-0.2-6.7-4.7-6.6c0.1-0.3,0.5-1.5,0.3-2.6c0.9,0,2.1-0.5,2.6,0.2c0.8,1.3,3.1,1.6,4.1,2.5c0.1,0.4,0.5,1.1,0.5,0.6 c0.1,0.1,0.2,0.1,0.2,0.2c0-0.3,0-1.2,0-1.5c0.9,0.3,0.5-0.4,0.4-1C44.6,8.5,44,7.4,44,7.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M13.3,25.7c-1.3,0.6-0.4,3.5,1.5,2.1c-0.4,0.4-0.5,0.5-0.9,0.6c-0.5,1.3,0.6,2.2,1.8,1.5 c0.7-0.4,1.9-1.6,2.7-1.3c-0.6,0.2-1.1,0.5-1.6,0.8c1.4-0.4,3.8,0.3,3.9-1.8c-0.1-1.5,0.5-6.7,2.5-4.7c-0.2-0.1-0.6-0.4-0.8-0.2 c0.8,0.4,1.1,1.3,1.1,2.2c0.1,1-1.5,1.7-2.1,2.1c-0.6,0.5-0.2,1.5-0.9,1.9c-0.9,0.9-2.6,0.3-3.8,0.7c-0.8,0.3-1.2,1-2.2,0.8 c0.4,2.9,1.7,0.3,3.1,0.5c-0.5,0.1-0.9,0.4-1.3,0.8c0.5,1.2,1.4-0.1,2.3-0.1c-0.1,0-0.2,0.1-0.4,0.3c0.4-0.1,1.7,0.2,1.9-0.5 c-0.9,0.2-1.5-0.5-2.5-0.7c6.2,1.6,2.3-1.3,5.3-3.6c1.4-0.6,1.8-2.4,1.5-3.7c-0.2-0.4-1-1.2-1.2-1.8c-1-0.7-2.7,0.5-3.2,1.6h0 c0.1-0.2,0.2-0.5,0.3-0.7c-0.6,0.6-1.1,1.9-2.2,1.6c0.1,0.1,0.1,0.3,0.1,0.4c0.5-0.4,1.2-0.4,1.6,0c0.1-1,1-2.5,2-2.7 c-0.3,0.6-1.4,2.6-1.6,3.4c0.1,0.9-0.6,2.3-1.5,1.6c1.2,0.3,1.6-1.8,0.6-2.3c-0.9-0.1-1.8,1.8-1.7,2.6c-0.1-0.3-0.2-0.8-0.2-1.1 l0,0c0-0.1,0-0.2,0-0.2c-0.5,1-1.6,1.4-2.5,0.7c0,0.1,0.1,0.5,0.1,0.4c-0.2-0.5-0.6-1.1-1.1-1.3c0.4,0.3,1.1,1.9-0.1,2 c-0.1-0.1-0.1-0.2,0-0.3c-0.1,0.3-0.5,0.4-0.6,0.1c0.6,0,0.4-2-0.1-1c0-0.2,0.1-0.5,0.2-0.5c0.6-0.2,0.7,1,0.5,1.3 C14.3,26.9,13.8,25.9,13.3,25.7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M25.2,31.8c-0.1,0-0.1-0.1-0.2-0.1c0.2-0.1,0.4,0,0.8,0.1c0-0.2,0.1-0.3,0.1-0.6c-0.6,0.2-1,0.3-1.3,0.3 C24.8,31.7,25,31.8,25.2,31.8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M11.3,20.5C11.3,20.5,11.3,20.5,11.3,20.5c-0.2,0.1-0.2,0-0.7,0c-0.3-0.1-1,1.5-1,1.7c0.2,1,0.5,2.6,0.2,3.4 c-0.1,0.6-1.2,1.7-1.4,2.5c0.1,2.7-1.1,4.3-3.6,5.4c1.2-0.3,2.4,0.1,3.2,1.1c0.5-0.2,0.4-0.4,0.2-0.8c-0.7-0.8,1.2-2,1.3-3 c0.1-0.4-0.4-0.6-0.3-0.9c-0.1-0.1-0.2-0.1-0.2-0.2c0,0,0.2,0.1,0.3,0.1c3.3-1.8,0.4-4.7,2.3-7.3C11.2,21.7,11.2,21.4,11.3,20.5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M11.5,20.2C11.5,20.2,11.5,20.1,11.5,20.2c-0.1,0-0.1,0.1,0,0.1h0c-0.1,1,0.2,2.5,1.4,2.8 c-0.4,0.2-0.8,0-1.1-0.4c-0.5,1.1,1.3,1.5,1.3,2.6c0.1-0.1,0.2-0.1,0.3-0.1c0.2-1,0.8-2.3,0.4-3.1C12.7,22.3,11.8,21.2,11.5,20.2 "
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M11.8,19.6c-0.2-0.2-0.5-0.4-0.6-0.5c0.1,0.4,0.4,1.2,0.9,1.2C12,19.9,12,19.8,11.8,19.6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M5.7,15.8c-0.1,0-0.2-0.1-0.3-0.1c1.2,3.8,4.8,0.7,5.7,4.5c0.1,0,0.1,0,0.2,0.1c0.1-0.4-0.4-0.8-0.2-1.3 c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.5-0.7-0.2-1.7,0.3-2.3c-0.1-0.1-0.1-0.2-0.2-0.3C9.3,16.6,7.5,15.9,5.7,15.8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M24.6,16.7c-0.1,0-0.3,0-0.4,0c-0.2,0.5-0.5,1.5-0.1,2.1c0.5-1.9,2.8-1.3,3.7-3c0.3-0.3,1.2-1.9,1.9-2.6 c-0.4,0.1-0.8,0.3-1.2,0.1c-0.8,0.7-1.6,1.4-2.8,1.8C25.8,15.7,25.5,16.7,24.6,16.7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M17.4,26c0,0.3,0.1,0.8,0.2,1.1c-0.1-0.8,0.9-2.7,1.7-2.6c-1-0.2-1.7,0.9-1.9,1.9h0 C17.4,26.3,17.4,26.1,17.4,26L17.4,26"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M21.8,21.7c-1,0.2-1.9,1.7-2,2.7c0.2,0.2,0.3,0.5,0.4,0.8C20.4,24.4,21.5,22.3,21.8,21.7"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M13.9,28.6c0-0.1,0-0.1,0-0.2c-0.1,0-0.3,0-0.5,0c-0.1,0.5,0.2,1.2,0.7,1.5C13.8,29.6,13.8,28.8,13.9,28.6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M17.4,31.2c-0.5,0.2-0.7,0.4-0.4,0.7c0.1,0,1.9-0.5,2-0.5C18.7,31,17.9,30.9,17.4,31.2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M14.5,23.5c0.1,0.1,0.1,0.2,0,0.3c-0.1-0.4-0.2-0.6-0.4-1.1c0.1,0.7-0.1,2-0.3,2.5c0.8,0.3,1.2,1,2.1,0.7 c-0.3,0.2-0.8,0.2-1.1,0.1c0.5,1.4,2.5,0.5,2.8-0.8c-0.4,0.3-0.6,0.4-1,0.4C18.1,25.4,15.7,19.1,14.5,23.5"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M12.1,16.2c-0.1,0-0.1,0-0.1,0.1L12.1,16.2L12.1,16.2"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M22.1,17.9c-0.8,1.6-1.1,3.5-3.6,3.2c0.3,1.5,3.1-0.6,3.1-1.8h0c0.2,1-0.6,2.4-1.7,2.5l0,0 c-0.4,0.1-1.1-0.1-1.5,0.1c-0.3,0.2-0.8,1.4-0.4,2.1c1.6,0.3,2.5-3.3,5.1-3.4C23.5,19.9,23.1,17.3,22.1,17.9L22.1,17.9"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M19.8,17.2c-0.6,1.1-1.6,2.4-1.8,3.5c0-0.1,0.1-0.1,0.1-0.2l0,0c1-1.5,2.5-2.7,2.9-4.2 C20.5,16.4,20.1,16.8,19.8,17.2"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M21.5,13.9c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2,1.1-1.6,1.1-2.4,2c-1.3,0.6-2.2,3.8-3.7,3.3 c0.1-0.5-0.2-0.8-0.5-1.1c0.1,0.3,0.1,0.6,0.1,0.9c-0.3-1.9-3.1-4.2-3.7-1.3c-0.2,1.3,1.1,1.7,1.7,2.6c1,1.1,2.6,1,2.1-0.6 c0.1,0.3,0.4,0.4,0.5,0.7c0-0.3,0.1-0.6,0.4-0.8c-0.1,0.3-0.1,0.6-0.1,0.8c1.6,0.4,2-2.4,3.1-3.2C19.2,15.8,22,15.5,21.5,13.9"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M27,8.3c0-0.1,0-0.2,0-0.3c-2.1-0.7-5,0.3-6.2,2.3c0.6,0.2,0.9,0.3,1.3,0.5c0.5-0.6,1.6-0.5,2.1,0.1 c1-0.1,1.9-0.7,2.4-1.5c-1.5-0.1-3,0.3-4.4,0.8c0.9-0.8,1.9-1,3.2-1.1l0,0c0.1,0,1.2,0,1.3,0C26.9,8.7,27,8.6,27,8.3"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M24,34.4c1-0.2,3.2,0.3,4.6,0.5c-0.1-0.2-0.7-0.9-0.8-1.1c0.3-0.1,0.6-0.1,0.8-0.1c0,0-0.1,0-0.1-0.1 C27.1,33.1,24.9,33.6,24,34.4"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M40.9,26.4c0,0,0-0.3,0-0.3c-1.3,0.9-0.3,3.2-1.4,4.1c-0.4,0.4-1,0.8-1.1,1.5c1.4-0.6,1.5-0.9,2.9,0.2 c-0.3-0.3-0.6-0.7-0.7-0.9c0,0.2,0,0.3,0,0.4v-0.4c-0.9-1.7,1.1-2.9,0.5-4.1c-0.1,0.2-0.2,0.4-0.3,0.6 C40.9,27,40.9,26.7,40.9,26.4"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M25.8,31.9c0.1,0,0.7,0.4,0.8,0.5c0.1-0.1,1.2-1.5,1.1-1.7c-0.1-0.2-0.8,0.4-1.8,0.5 C25.9,31.5,25.8,31.9,25.8,31.9z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M5.1,33.5c-0.4,0-0.6,0.5-0.4,0.8c1.2-0.3,2.3,0,3.4,0.6c-0.9-0.7-1.9-1.4-2.9-1.1c0.1-0.1,0.1-0.2,0.2-0.3 C5.3,33.5,5.2,33.5,5.1,33.5"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M11.5,23.7c0-0.2,0-0.9,0.2-1.1c-1.5,1.6-0.5,3.4-0.8,5.5c-0.1,0.9-1.2,1.7-1.8,1.7c0.4,0.5,0.6,0.7,0.5,1.1 c-0.1,0.9-2,2.2-1.3,3c0.2,0.4,0.3,0.6-0.2,0.8c0,0-0.1,0-0.1-0.1c0.2,0.3,0.6,0.8,0.9,0.9c0.1-1.3,0.4-2.3,0.6-2.7 c-0.2,0.1-0.4,0.1-0.6,0.2c0.8-1.1,1.7-2.6,2.7-3.4c-0.1,0-0.3,0.2-0.3,0.1c0.6-0.3,1-0.9,1.1-1.4c-0.3,0.1-0.6,0.2-1,0.1 C12,27.4,11.8,24.7,11.5,23.7"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M11.8,19.6c0.1,0.2,0.2,0.3,0.3,0.7H12c0.3,0.2,0.6,0.5,1,0.6C12.5,20.2,12.4,20.1,11.8,19.6"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M26,17.7c0.1-0.1,0.1-0.2,0.2-0.2c-0.8,0.2-1.5,0.5-1.8,1.1C24.8,18.2,25.7,18.4,26,17.7"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7,25.6c0,0.3,0.3,0.7,0.6,0.4c-0.3,1-1,0.2-1-0.4c-0.1-0.9,1.3-1,0.9-0.1C19.5,24.9,18.7,25.1,18.7,25.6"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.8,31.6c0.2-0.6,1.8-0.9,2.1-0.3c-0.1,0-1.9,0.5-2,0.5C16.9,31.8,16.8,31.7,16.8,31.6"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20.1,30.8c-0.8,0-1.1-0.5-2-0.6v-0.1c0.3-0.2,2.5-0.5,2.8-0.4C21.5,30,20.7,30.7,20.1,30.8"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.7,20.2c0.7,1.7,2.9,1.5,2.2-0.4C14.9,21.2,13.7,21.2,12.7,20.2"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M22.9,11.6c-1,1,0.5,3.8-0.4,3.2c0.2,0.5,0.1,1.1-0.1,1.7h0c0-1.1-0.1-2-0.9-2.5c0.6,1.6-2.3,1.9-3,3.1 c-1.1,0.8-1.5,3.6-3.1,3.2c1.7,2.2,3.4-2.8,4.4-3.6c0.8-1,2.5-0.6,2.2,0.7c-0.1-0.5-0.4-1.1-1.1-1c0,0.1,0.1,0.1,0.1,0.2 c0-0.1,0.1-0.1,0.1-0.1c-0.2,0.9,0.3,1.8,0.1,2.8c-0.1,1.5-1.9,2.2-3,1.4c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0.1-0.1,0.1-0.1 c-0.1-0.2-0.1-0.5,0-0.8c-0.9,0.7-0.9,2-0.9,3l0,0c-0.2-0.5-0.4-1.4-0.3-2c-0.6,0.3-1.3,0-1.5-0.5c0,0.6-0.5,1.2-1.2,1.2 c0.3,0.6,0.3,1.2,0.4,1.9c1.1-3.6,2.9-0.1,2.7,1.9c0.2-0.2,0.6-0.5,0.9-0.8c-0.5-0.8-0.4-2-0.3-2.7h0.1c-0.1,0.2,0.1,0.7,0.1,1.1 c0.4-1.6,0.9-1.1,2-1.2c-0.5,0-0.9-0.1-1-0.2c1.2,0.2,2.3-0.7,2.6-1.8c-0.5,0.9-1.3,1.7-2.3,1.7c-0.5,0-0.8-0.2-0.6-0.4 c2.4,0.3,2.8-1.6,3.6-3.2c1-0.5,1.3,2.1,1.1,2.7c-0.8,0.1-1.1,0.3-1.6,0.7c1.7-1,1.9,0.3,2.7,1.4c2.6-2-1.8-3.9-1.1-6 c0.1,0.4,0.2,0.9,0.4,1.3c0-0.6,0.1-1.1,0.4-1.3c-0.4-0.1-0.8-0.4-0.9-0.6c0.9,0.8,2.4,0.5,2.4-0.8c-2.3,1-3-2.6-2.2-4.1 C23.2,11.2,23.1,11.3,22.9,11.6"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M38.3,32C38.3,32,38.3,32,38.3,32c-0.2,0.1-0.3,0.2-0.4,0.3c1.1-0.8,2.6-0.5,3.6,0.4 C42.3,31.4,39,31.5,38.3,32"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M40.5,19.8c-0.4,2.1-0.3,4-1.5,5.9c-0.2,0.3-0.4,1-0.7,1.3c-0.1,1.8,1.9-0.3,1.9-1.3c0,0,0,0,0.1,0 c0.2,1.6-1.6,1.9-1.6,3c0.2,1.2-0.4,1.6-0.4,1.6c0-0.4-0.2,0.1-0.3-0.3c0.1,0.7,0,1.3-0.3,2.1c0.1-0.1,0.4-0.3,0.6-0.3 c0.1-0.7,0.7-1.1,1.1-1.5c1.2-0.9,0.1-3.2,1.4-4.1c0-0.1,0.1-0.5,0.4-1.1C40,23.4,41.3,21.4,40.5,19.8 C40.5,19.8,40.5,19.8,40.5,19.8"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M36.3,16.6L36.3,16.6c-0.1,0.1-0.4,1.5-0.4,1.5c-0.4-3.1-4.2-4.3-6-6.5c-0.3,0.5-0.6,1-1,1.4 c0.6,0.2,1.6-0.4,2.2-0.3c-0.8,0.4-0.9,1.2-1.1,2l1.2-0.2c-1.3,1.3-1.4,4.3-1.8,6c-0.1,1.8-2.2,3.1-1.2,4.7 c0.2-0.3,0.4-0.6,0.8-0.9c0.1-0.1,0.7-1.4,0.7-1.4c-0.4,1-1.3,3.1-0.7,4.4c0.1-0.4,0.4-0.8,0.8-1c-0.3,2.1-0.8,3.1-0.6,4.9 c-1.3-0.6-2.8,2-0.8,2.3c0,0.1,0,0.1,0.1,0.1c-0.2,0-0.5,0-0.8,0.1c0.5,0.9,2,1.5,1.7,2.7c0-1.2-1.3-1.9-2.3-1.8 c-1.5-0.2-3.9-1.2-3.4,0.7c0.9-0.4,2.4-0.5,2.9,0.6c1.2-0.3,2.4-0.1,3,1.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-1.2-0.3-2.1-0.9-3.1 c0.3,0.2,0.6,1,0.8,1.6c0.1-3.3,3.4-2.5,3-5.6c0.1-1.1,0.4-2.3,0.7-2.3c-0.3,0.5-0.3,1.2-0.3,2c1.1-1.4,2.5-2.1,3.2-3.7 c0.7-1.6,0.9-4.1-0.3-5.4c-0.9-1.1-3.4-2.7-3.4-4.4c0.2,0.5,0.4,0.8,0.7,1.2l0,0l0,0l0,0c0.8,0.7,2.2,1.7,2.6,2.1 C37.1,19.1,36.5,17.3,36.3,16.6"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M31.8,17.6c1.8,1.2,3.4,3.4,3.3,6c-0.2,1.3-1.7,2.7-2.6,3.9c-0.8,1-0.3,3.2-1.7,3.3 c-1.7,0.2-0.6-1.3-0.3-2.2c0.5-1.2-0.1-2.2-0.1-3.5c-0.1-0.3,0.4-1.7,0.4-2.4C31,22.3,30.9,18.4,31.8,17.6"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M29.7,31.3c0,0,0-0.1,0-0.1h0c0.4,1.2,1.2,0.7,2.3,0.8C31.1,32.5,29.7,32.5,29.7,31.3"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M31.1,32.6c-0.5,0.4-1.3,0-1.3-0.6c0.2,0,0.3,0.2,0.4,0.3C30.3,32.6,30.8,32.6,31.1,32.6 C31,32.6,31,32.6,31.1,32.6"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M35.8,8.9c0.2,0,0.5,0,0.8-0.1c0.1,0.2,0.1,0.3,0,0.4c-0.8,0.1-0.6,1.3-0.9,2c-0.2-0.1-0.4-0.3-0.5-0.1 C36,9.9,35.8,8.9,35.8,8.9z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M43.3,8L43.3,8c0.8,1.2,1.1,1.6,1.2,2.7c0.1,0,0.1,0,0.2,0c-0.3-3.9-2.3-5-5.6-3.4c-1.3,0.3-5.7,1.5-6.1,0.1 c0.5,0.8,2,0.4,3,0.3c-1-0.3-1.9-0.6-2.9-0.6c-0.3-0.3-1.4,0.2-1.5,0.6c-0.3,0.9,2.2,0.9,2.9,1c1.6,0.1,3.3-0.5,4.8-0.3 C39,8.2,38.8,8,38.6,7.9h0c0,0-0.1,0-0.1-0.1c0.5,0.1,1.1,0.6,1.2,0.9c0.8,1.3,2.9,1.4,3.9,2.4c-0.2-0.6-0.3-1.1-1-1.9 c1.1,0.5,1.1,1.7,1.5,2.5C44.3,10.2,43.9,9.3,43.3,8z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M32.1,17.7c-1.2-0.4-1,5.4-1.2,5.4c-0.9,2.1,0.3,3.5-0.3,5.4c-0.3,0.8-1,1.7-0.4,2.2 c2.2,0.5,1.5-2.6,2.6-3.7C36.5,23.8,35.3,20.4,32.1,17.7"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M39.7,12.4c-0.8-0.7-3.1-0.8-3.1-0.8c-1.4-0.2-2.9-0.7-4.3-1.4c1.7,1.3,2,3.6,3.7,4.7v0 c-2.2-1.3-3.2-4.6-5.5-5.9c0,0.5-0.1,0.9-0.2,1.3c0.6,0.5,1.3,1.1,1.8,1.7c-0.6-0.5-1.4-1.1-1.9-1.5c-0.1,0.3-0.3,0.7-0.4,1 c1.8,2.2,5.6,4,6,7c0.3,0.1,0.4-1.7,0.5-2.1c0.1-0.4,1.4,5.8,1.2,7.1c1.3,1.7,3-3.9,2.9-5h0c-0.1,1,0.4,2,0.3,3 c-0.1,0.9-0.4,2.4,0.5,3.1c1.4-2.9,0.7-3.7-0.3-6.6C40.5,16,41.6,14.4,39.7,12.4z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M37.2,15.2c-0.1-0.1-0.1-0.3-0.1-0.5h0c0.7,1,2.7,1.4,3.1,2.9l0,0C39.8,16.4,37.9,16.1,37.2,15.2"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M36.3,11.3c0.2-0.6,0.4-1.5,0.4-2.1c-0.8,0.1-0.6,1.3-0.9,2C36,11.2,36.1,11.3,36.3,11.3z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M29,37c-1.8-2-4.8,1-3.4,3C27.7,41.1,29.5,39.2,29,37"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M23.8,35.9c-1.7,1.1-3.3,4.9,0.3,4.1c0.4-1.2,1.1-3,2.2-3.8C25.9,35.3,24.5,35.4,23.8,35.9"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M22.6,34.2c0.8,0.3,2.1-0.8,2.3-1.6C23.9,32.2,22.2,33.1,22.6,34.2"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M22.6,32.5c-0.8-0.1-1.3,0.6-1.5,1.3c0.9,1.2,1.4-0.6,2-1.1C22.9,32.5,22.8,32.5,22.6,32.5"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M5.5,34.8c-1.3-0.1-2.6,0.3-3.3,1.5c-0.4,0.8-1.1,1.7-0.4,2.1C2.5,38,3,36,4.1,35.4c-2.2,3-1,4,2.2,2.9 C7.6,37.6,7.4,34.7,5.5,34.8"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M6.7,6.1c-0.3,0-0.7,0-0.9,0c1.5,0.4,1.5,2.4,0.8,3.5C6.7,9.1,7,7.9,6.8,7.5c0.1,0.9-0.6,1.8-0.9,2.8 c-1.4,3.4,1.4,6.5,4.9,5.5c-0.4-0.8-0.7-2-0.3-2.9C4.4,13.3,10.6,6.2,6.7,6.1"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M25.5,2.4c0-0.4,0.1-0.8,0.2-1c-2.4,3.4,1.5,3.6,2,5.1c-0.2-0.4-1-1-1.5-1.2c2.2,1.7,1.1,5.4-1.6,5.8 c-0.5,0.1-0.9,0.1-1,0.1c-0.3,0.2-0.3,1.5-0.3,1.9c0.6,5,7.4-1,7-3.7c0.7-3.4-4.9-4.8-4.2-8.1c-0.8,1.6,0.3,3.1,1.7,4 C26.7,4.5,25.5,3.8,25.5,2.4"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M41.9,33.8c-1.8-3-5.2,0.2-3.4,1.5c1.7,0.6,1.5-0.9,1.6-1.8c0.2,1.2,0.7,2.8,2.2,1.5 C42.2,34.6,42,34,41.9,33.8z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M24.5,38.7c-0.3,0.4-0.1,1-0.4,1.3c-0.7,0.2-2,0-2.3-0.5c0,1.4,1.9,1.7,3.1,1.2l0,0c0,0.1,0-0.6,0-0.5 c0,0,0.1,0.1,0.1,0.3c0.4,0.9,1.6,0.7,2.4,0.7c1.8-0.2,2.6-0.7,2.3-2.2h0h0c-0.1-0.7-0.3-1.5-0.8-2c0.3,1.6-0.3,3.5-2.3,3.3 c-0.8,0-1.3-0.3-1.6-1.2C25,39.4,25,39.7,25,39.9c-0.1-0.9-0.1-1.3,0.2-2.3C25,38,24.8,38.4,24.5,38.7"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M22.9,34.2c-0.3,0-0.3,0-0.5-0.3c-0.1,0.2-0.1,0.3-0.1,0.5h0c-0.1-0.4-0.1-0.5,0.1-0.9 c-0.4,0.5-1,0.6-1.3,0.1c-0.4,0.8,0.3,1.4,1.1,1.2c0-0.1,0.1-0.2,0.1-0.2c0.2,0.2,0.6,0.8,1,0.6c-0.2-1.3,1.5-1.6,2.4-2 c-0.2-0.3-0.5-0.5-0.9-0.6C24.8,33.3,23.6,34.3,22.9,34.2"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M6.2,38.3c-0.5,0.4-3,0.8-3.4-0.1c-0.3,1.6,2.5,1.3,3.9,1.1C8.2,39,7.9,39,8.1,37.7c0-1-0.5-2.2-1.5-2.5 C7.4,36.1,7.3,37.7,6.2,38.3"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M2.7,37.2c-0.5,0.6-0.8,1.5-1.2,1C1.3,39,2,39,2.6,38.9C2.5,38.4,2.4,37.8,2.7,37.2"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M38.6,33c-3.2,2,0.8,4.7,1.3,1.8c0,0-0.9,0.7-1.6,0.1C37.9,34.6,38.1,33.6,38.6,33z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M40.2,34.1c0.1,0.7,0,1.3-0.2,1.9c0.9,0.3,2.5,0,2.2-1.1C41.1,35.9,40.4,35.2,40.2,34.1z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M22.7,23.3c0.1,0.4,0.1,0.8-0.1,1.2c0.6,0.1,0.5,1.1,0,1c0,0.3-0.3,0.5-0.5,0.4c0,0.3-0.3,0.6-0.5,0.4 c0,0.2-0.2,0.4-0.4,0.4c0,0.2,0,0.3,0,0.5C22.5,25.9,24.2,25.4,22.7,23.3"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M4.7,34.3c0,0,0,0.1,0,0.1c1.5-0.1,2.9,0.6,3.5,1.7c0.4-0.1,1.1-0.2,1-0.6c0.2-1.2,0.5-2.4,0.9-3.5 c-0.3,0.3-0.7,0.6-1.1,0.8c0.2,0,0.4-0.1,0.6-0.1c-0.3,0.5-0.5,1.3-0.6,2.7c-0.1-0.1-0.3-0.1-0.5-0.3c0,0.1,0.1,0.1,0.1,0.2 C7.5,34.4,6.1,33.9,4.7,34.3"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M9.9,31.6c-0.1,0.2-0.2,0.4-0.3,0.6c1-1.1,2.3-2.2,3.6-2.7c-0.1-0.2-0.1-0.3-0.1-0.5 C11.7,29.3,10.6,30.4,9.9,31.6"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M12.7,25c-0.2-0.5-0.6-0.6-1.1-1.1c0,1,0.4,3.6-0.2,4.3c0.4,0.1,0.7,0,1-0.1c-0.1,0.4-0.3,0.7-0.5,1.1 c0.3-0.2,0.9-0.5,1.2-0.6c0-0.1,0-0.2,0-0.2c-1-0.5-1.1-2.2-0.2-2.9C12.9,25.4,12.8,25.2,12.7,25"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M28.7,25.8c-0.3,1.1,0.2,2.4,0.1,3.4c0.2-0.5,0.4-1,0.5-1.5h0c-0.2,1.8-1.5,4.2-3.1,5.6 c0.6-0.1,1.2,0.1,1.7,0.2c-1.2-0.5,0.2-2.8,1.3-2.2c-0.2-1.8,0.3-2.7,0.6-4.9c-0.4,0.2-0.7,0.5-0.8,1 C28.8,26.9,28.7,26.4,28.7,25.8"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M29.9,14.8c-0.2,2.6-2.6,4.4-5,4.8c1.2,1.1,0.8,2.5-0.3,3.5c0.2,0.2,0.2,0.6,0.2,0.9 c1.1-1.2,1.8-2.7,2.3-4.1c-0.1,1.5-1,3.8-2.3,4.6c0,1.8-0.8,2.2-2.1,3.1c-0.8,0.9-1.1,2,0.2,2.7c0.7,0.6,0.8,1,1.7,1 c1.3-0.1,2.7-1,3.9-1.7c0.2-0.8,0.1-1.2,0-2c-0.3-0.1-0.7-0.6-0.9-1c-0.8,1.5-1,1.8-3,2.7h0c0.8-0.5,2.3-1.8,2.7-3.1 c-1.7-3.1,1.4-2.7,1.5-7.6h0c0.5,4.5-3.6,4.9-0.4,8.5c0-0.9,0.2-2,0.6-2.7c-0.3,0.2-0.6,0.5-0.8,0.9c-1.1-1.6,1.1-2.9,1.2-4.7 c0.3-1.7,0.5-4.6,1.8-6l-0.8,0.1L29.9,14.8"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M39.6,31.9c-0.6,0-2.4,0.2-1.7,1.1c1-1,2.6-1.2,3.6-0.3c0,0,0,0,0,0C40.9,32.3,40.4,32,39.6,31.9"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M40.1,22.2c0-0.1,0-0.2,0-0.3c-0.5,1.8-1.7,3-3.2,4c-0.2,2.1,1.3,2.6,1.5,4.6c0.8-0.6,0.4-1.7,0.7-2.5 c-1,0.1-1.6,0.3-1.7-0.8c0.4,0.5,0.7,0.6,1.2,0.5C37.6,27,40.6,24.8,40.1,22.2"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M36,19.3c-0.4-0.4-1.8-1.5-2.6-2.1l0,0l0,0l0,0c0.8,1.2,2.2,2,3.1,3.2c0.1-0.5,0.2-1.1,0.1-1.6 C36.5,18.9,36.3,19.4,36,19.3z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M13.6,21.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.2,0,0.3,0C13.7,21.7,13.6,21.6,13.6,21.6 C13.6,21.6,13.6,21.6,13.6,21.6"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M11.9,20.5c0.2,0.4,0.3,0.6,0.6,0.9c-0.1-0.2-0.2-0.5-0.1-0.6C12.2,20.7,12,20.6,11.9,20.5"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M20.9,17.3c0-0.1,0-0.1,0-0.1c-0.1,0.3-0.4,0.6-0.5,0.9c0.2-0.2,0.5-0.2,0.6,0C21,17.8,20.9,17.3,20.9,17.3 "
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M19.8,18.8c-0.3,0.5-0.7,1.1-0.6,1.7c0.5,0,0.9-0.2,1.2-0.6c-0.6-0.1-0.7-0.9-0.4-1.5 C20,18.6,19.9,18.7,19.8,18.8z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M12.5,20.8c-0.1,0.4,0.6,1.2,0.9,0.6C13.2,21.3,12.9,20.9,12.5,20.8"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M13,21.4c-0.1,0-0.2-0.2-0.2-0.3C12.8,20.8,13.3,21.4,13,21.4z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M19.7,19.1c0.1-0.1,0.1-0.2,0.2-0.3c-0.3,0.5-1,1.2-1.5,1.6c0,0.1,0.7,0.1,0.9,0.1 C19.2,20,19.4,19.5,19.7,19.1z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M22,10.9c0,0-1.7-0.7-4.3-0.8c-2.6-0.1-5,2-5.4,2.9c-0.4,0.9-0.4,1.4-0.2,3c0.3-0.1,0.2,0.2,0,0.2v0.1 c-0.1,0-0.2,0-0.2,0.1c0.7-0.3,1.4,0.4,2.1,1.1c-0.1-0.1-0.4-0.4-0.6-0.5c0.8,0.5,1.1,1.2,1.7,1.8c0.2,0-0.2-1.5,3.6-4.6 c0.9-0.7,2.6-0.6,3.2-0.1c-0.2-0.3-0.4-0.8-0.4-1.2c0,0.1,0,0.1,0,0.2C21.4,12.2,21.6,11.5,22,10.9C22,10.9,22,10.9,22,10.9"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M21.1,9.6L21.1,9.6c0.3-0.3,0.6-0.6,1-1C21.5,9,20.4,9.8,19.9,10c0.3,0.1,0.7,0.2,1,0.2 c0.2-0.3,0.3-0.5,0.5-0.8C21.3,9.5,21.2,9.6,21.1,9.6"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M27,7.9c0-0.1,0-0.3,0-0.4c-3-1.3-3.1-0.4-5.2,1.6C23.4,8,25.2,7.5,27,7.9z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M26.2,1.2c0.1-0.1,0.1-0.2,0.2-0.3C24,2.4,26.7,5,27.8,5.3C26.7,4.2,25.3,2.8,26.2,1.2z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M38.3,32C38.3,32,38.3,32,38.3,32c0.9-0.5,2.2-0.5,3.1,0c-0.8-0.7-1.7-1.4-2.6-0.4c0.2,0,0.3,0,0.5-0.1 C39,31.6,38.6,31.8,38.3,32"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M41.5,25.1c-0.2,0.3-0.4,0.8-0.6,1c0,0.3-0.1,0.9-0.1,1.4c0.1-0.2,0.2-0.4,0.3-0.6c0.1,0.2,0,0.6,0.1,0.8 C41.4,27.3,41.5,25.3,41.5,25.1z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M14.8,27.8L14.8,27.8c0.2,0,0.3-0.1,0.6-0.2c0.3-0.5,3.2,0.1,2.3-0.6c-0.4-0.4-0.5-1.2-0.1-1.9 c-0.8,0.7-2.2,0.9-3,0.9C14.9,26.8,15,27.4,14.8,27.8C14.8,27.9,14.8,27.8,14.8,27.8z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M7,12.2c-0.2-0.4-0.2-1.1,0-2.1c-1.2,2.5,0.8,4.6,3.3,4.3l0-0.6C9.4,14,7.3,13.5,7,12.2"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M12.2,20.8C12.2,20.8,12.1,20.8,12.2,20.8c0,0.3,0.4,0.2,0.6,0.2C12.7,21,12.3,20.9,12.2,20.8"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M19.7,19.4c-1.1,1,0.4,0.6,0.5-0.6C20,19,19.9,19.2,19.7,19.4z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5,14.5c0.5-0.8,1.8-1.7,2.7-1.3c-2.5-0.4-3.6,5.4-5.8,2.2C14.6,16.7,15.8,15.8,16.5,14.5"
});

function SvgEtLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119 42",
    style: {
      enableBackground: "new 0 0 119 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Bull"
  }, /*#__PURE__*/React.createElement("g", null, _ref4, _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.5289,
    y1: 302.7504,
    x2: 25.8597,
    y2: 302.7504,
    gradientTransform: "matrix(1 0 0 -1 0 334.3086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4935,
    style: {
      stopColor: "#E50000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    style: {
      stopColor: "#F31619",
      stopOpacity: 0.8061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2A30",
      stopOpacity: 0.6
    }
  })), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165953500195259889220000009332168031690603954_",
    cx: 13.876,
    cy: 307.6729,
    r: 0.8405,
    gradientTransform: "matrix(1 0 0 -1 0 334.3086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F26A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6287,
    style: {
      stopColor: "#EE2542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#9A061A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165953500195259889220000009332168031690603954_)"
    },
    d: "M13.7,25.6c-0.2,0-0.2,0-0.4,0.1 c0.5,0,0.8,1.4,0.3,1.7c0,0.2,0.1,0.2,0.1,0.2C14.7,27.8,14.7,25.8,13.7,25.6"
  }), _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147936435890902556300000005808500156192227004_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0628,
    y1: 302.0168,
    x2: 26.3198,
    y2: 302.0168,
    gradientTransform: "matrix(1 0 0 -1 0 334.3086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4935,
    style: {
      stopColor: "#E50000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    style: {
      stopColor: "#F31619",
      stopOpacity: 0.8061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2A30",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147936435890902556300000005808500156192227004_)"
    },
    d: "M25.2,31.8c-0.8-0.3-1.8-0.5-2.6-0.1 c-0.4,0.1-0.6,0.1-0.6,0.4c0.3-0.1,1.1-0.2,1.2,0.2c0.8-0.4,2.2-0.2,2.6,0.6c0.1-0.1,0.3-0.3,0.4-0.4C26,32.3,25.6,32,25.2,31.8"
  }), _ref24, _ref25, _ref26, _ref27, _ref28, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000100367053817413201390000007079037704237835399_",
    cx: 22.6592,
    cy: 308.3103,
    r: 2.3037,
    gradientTransform: "matrix(1 0 0 -1 0 334.3086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    style: {
      stopColor: "#C33332"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    style: {
      stopColor: "#E50000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100367053817413201390000007079037704237835399_)"
    },
    d: "M24.1,24.3c0.1,3.1-2.3,1.9-3,4.6 c-0.3-2.6,3.9-2.1,2.2-5.8C23.7,23.8,24.2,23.6,24.1,24.3"
  }), _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000129163513704812490560000017136656049921354686_",
    cx: -197.8996,
    cy: -708.3264,
    r: 0.6055,
    gradientTransform: "matrix(1 0 0 1 220.1 733.8337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129163513704812490560000017136656049921354686_)"
    },
    d: "M22.3,25.7c0.3-0.2,0-0.6-0.2-0.8 c-0.1,0.2-0.1,0.2-0.3,0.3c0,0.1,0,0.1-0.1,0.2c0.1,0.1,0.3,0.3,0.3,0.4C22.1,25.8,22.2,25.8,22.3,25.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000174578897225402572840000017944673052532264613_",
    cx: -194.3644,
    cy: -711.7014,
    r: 0.4569,
    gradientTransform: "matrix(1 0 0 1 216.1 737.6337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174578897225402572840000017944673052532264613_)"
    },
    d: "M21.3,25.9 C21.3,25.9,21.3,25.9,21.3,25.9c0.1,0.1,0.2,0.1,0.2,0.3c0.4,0.1,0.5-0.4,0.1-0.6c-0.1,0.1-0.2,0.1-0.3,0.1 C21.4,25.8,21.4,25.9,21.3,25.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000017496969529459080910000014025370519679934376_",
    cx: -190.9038,
    cy: -714.4449,
    r: 0.3375,
    gradientTransform: "matrix(1 0 0 1 212.2 740.7336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017496969529459080910000014025370519679934376_)"
    },
    d: "M21.3,26c0,0-0.1,0.1-0.1,0.1 c0,0.2,0,0.3,0,0.5C21.4,26.5,21.5,26.2,21.3,26z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139271583135348330250000015347198286941443203_",
    cx: -190.1833,
    cy: -710.0111,
    r: 0.2887,
    gradientTransform: "matrix(1 0 0 1 211.4 735.7336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139271583135348330250000015347198286941443203_)"
    },
    d: "M21.3,25.7c0,0,0-0.1-0.1-0.2 c0,0.1,0,0.3,0,0.4C21.2,25.8,21.3,25.8,21.3,25.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047059813471805101740000000933769570835934643_",
    cx: -195.1444,
    cy: -707.3508,
    r: 0.629,
    gradientTransform: "matrix(1 0 0 1 217 732.7336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047059813471805101740000000933769570835934643_)"
    },
    d: "M21.2,25.4c0.1,0.1,0.1,0.2,0.2,0.3 c0,0,0,0,0.1,0l0,0c0.3-0.3,0.2-0.5-0.1-0.9C21.3,24.9,21.3,25.1,21.2,25.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000176737089627178448650000007864307223860372392_",
    cx: -200.8337,
    cy: -705.6661,
    r: 0.6374,
    gradientTransform: "matrix(1 0 0 1 223.4 730.8337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176737089627178448650000007864307223860372392_)"
    },
    d: "M22.3,24.8c0,0-0.1,0.1-0.1,0.1 c0.2,0,0.4,0.4,0.4,0.5c0.4-0.2,0.4-0.8,0-0.9C22.5,24.6,22.4,24.7,22.3,24.8C22.3,24.7,22.3,24.8,22.3,24.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000168825500138636878350000003386223102646662333_",
    cx: -198.2494,
    cy: -703.8038,
    r: 0.9176,
    gradientTransform: "matrix(1 0 0 1 220.5 728.7336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168825500138636878350000003386223102646662333_)"
    },
    d: "M21.4,24.6c0.2,0.1,0.4,0.5,0.4,0.6 c0.4-0.4,0.1-0.9-0.3-1.1C21.5,24.3,21.4,24.4,21.4,24.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000038401309365731525610000018300542735443216516_",
    cx: -200.4758,
    cy: -700.6559,
    r: 1.0637,
    gradientTransform: "matrix(1 0 0 1 223 725.1837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038401309365731525610000018300542735443216516_)"
    },
    d: "M21.8,23.4c-0.1,0.2-0.2,0.4-0.3,0.6 c0.2,0.1,0.5,0.3,0.6,0.7C22.2,24.4,22.1,23.6,21.8,23.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047746976248658023540000004788659866910260650_",
    cx: -202.2412,
    cy: -694.8919,
    r: 0.8621,
    gradientTransform: "matrix(1 0 0 1 225 718.6837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A8A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047746976248658023540000004788659866910260650_)"
    },
    d: "M22.6,23.6c0-0.4-0.1-0.7-0.4-0.7 c-0.1,0.1-0.2,0.3-0.3,0.5c0.4,0.2,0.5,0.7,0.5,1.2C22.6,24.3,22.6,24,22.6,23.6z"
  }), _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000019669251639902791400000012648795324928256172_",
    cx: -86.7868,
    cy: -674.5399,
    r: 2.8525,
    gradientTransform: "matrix(1 0 0 1 94.8 695.7336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019669251639902791400000012648795324928256172_)"
    },
    d: "M8.7,18.9c-0.1-0.1-0.1-0.1-0.1-0.1 c0,0,0-0.1,0-0.1c0.2,0.3,0.9-0.1,1.3-0.1c-0.6-0.4-1.9-0.4-2.6-0.6c1,1.3,2.1,2.1,3.8,2.1L11,20l0,0c0-0.2-0.3-0.6-0.5-0.9 c-0.3,0.2-0.9,0.6-1.1,0.3c0.2,0.1,0.6-0.2,0.9-0.5C9.9,18.6,9,19.2,8.7,18.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000111876015033407733310000006134063904412859574_",
    cx: -395.1235,
    cy: 248.7095,
    r: 5.2273,
    gradientTransform: "matrix(0.8208 -0.5712 0.3102 0.4461 276.8722 -318.4399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111876015033407733310000006134063904412859574_)"
    },
    d: "M24.2,18.8c0.2,0.2,0.3,0.4,0.5,0.6 c4.2-1,4.2-2.8,5.6-6.3c-1.6,1.2-2,3.6-3.8,4.5c1-0.2,1.2-0.4,1.8-1c-0.3,0.8-1.6,1.3-2.2,1.6c0.2,0,0.5,0,0.8,0.1 C26.6,18.4,24.5,18.6,24.2,18.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000029730801048556811780000005430663443469447322_",
    cx: -1064.144,
    cy: 1026.1969,
    r: 2.8503,
    gradientTransform: "matrix(6.007186e-02 -0.9982 0.6082 3.704431e-02 -547.6622 -1085.6259)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6039,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029730801048556811780000005430663443469447322_)"
    },
    d: "M11.6,12.1c0.3-0.1,0.6-0.1,1,0.1 c-0.4,0.5-1.2,2-0.7,3.9c-0.1-0.2-0.3,0.1-0.4,0.2C10.6,15.3,10.1,12.7,11.6,12.1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120557775165613357380000015497244362489224862_",
    cx: -1063.6968,
    cy: 1024.7351,
    r: 0.01853745,
    gradientTransform: "matrix(6.007186e-02 -0.9982 0.6082 3.704431e-02 -547.6622 -1085.6259)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6039,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120557775165613357380000015497244362489224862_)"
    },
    d: "M11.7,14.1L11.7,14.1 C11.7,14.1,11.7,14.1,11.7,14.1z"
  }), _ref75, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000128450216284479788250000006309344653951255472_",
    cx: -438.958,
    cy: 198.3447,
    r: 1.5683,
    gradientTransform: "matrix(0.7071 -0.7071 0.5474 0.5474 223.2621 -399.7642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#373737"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128450216284479788250000006309344653951255472_)"
    },
    d: "M20.1,19.1c0.4,1.6,1.2-0.1,0.9-0.9 C20.5,17.7,20,18.7,20.1,19.1z"
  }), _ref76, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016772373397710788490000005495547405178577556_",
    cx: -205.8489,
    cy: 72.3561,
    r: 5.982,
    gradientTransform: "matrix(0.9522 -0.3055 0.142 0.4426 201.9249 -84.3701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5451,
    style: {
      stopColor: "#FF232B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016772373397710788490000005495547405178577556_)"
    },
    d: "M21.9,10.9c-0.5-0.2-0.8-0.3-1.1-0.4 c-0.3-0.1-1.6-0.3-1.9-0.4c-1.5-0.3-3.6,0.1-5.5,1.6c-0.7,0.5-2,2.5,0.2,2.8C16,14.3,19.7,12.8,21.9,10.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000144324001686273131660000014736405548440190389_",
    cx: -1089.4209,
    cy: 909.4182,
    r: 3.0436,
    gradientTransform: "matrix(5.070321e-02 -0.9987 0.5991 3.023586e-02 -465.9693 -1102.1987)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#FF232B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144324001686273131660000014736405548440190389_)"
    },
    d: "M24,10.9c-1.7-1.3-3.1,1.8-2,3 c0.3,0.2,1,1.4,0.9,0.7C22.8,13.7,22.2,11,24,10.9z"
  }), _ref77, _ref78, _ref79, _ref80, _ref81, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000166667206490444388090000009365326348981045130_",
    cx: -716.6012,
    cy: 1399.4304,
    r: 2.9978,
    fx: -715.921,
    fy: 1396.8864,
    gradientTransform: "matrix(0.204 -0.9661 0.4599 0.1553 -485.8237 -884.723)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5294,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166667206490444388090000009365326348981045130_)"
    },
    d: "M11.6,22.1c-2.3,0-1.7,7.1,0.7,5 c0-0.1-0.2-0.9,0.5-1.6c-0.2-0.8-0.8-1.2-1.2-1.9C11.5,23.6,11.8,22.5,11.6,22.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000063610132664506306010000000665507024192300219_",
    cx: -303.3075,
    cy: 776.1335,
    r: 0.05681664,
    gradientTransform: "matrix(0.7071 -0.7071 0.3176 0.3176 -23.2318 -425.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6039,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9608,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063610132664506306010000000665507024192300219_)"
    },
    d: "M8.8,35.2C8.8,35.2,8.8,35.3,8.8,35.2 C8.8,35.3,8.8,35.2,8.8,35.2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000129886132181031485470000010285649753555463050_",
    cx: -300.5573,
    cy: 772.9045,
    r: 2.9667,
    gradientTransform: "matrix(0.7071 -0.7071 0.3176 0.3176 -23.2318 -425.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6039,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9608,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129886132181031485470000010285649753555463050_)"
    },
    d: "M8.7,31.5c-0.5,0.4-1,0.6-1.1,1.3 c0.5,0.6,1,1.3,1.3,2c-0.1-0.8,1.8-4.3,1.8-4.4C10.1,30.5,8.9,31.3,8.7,31.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016055701712927022050000008170924227494551457_",
    cx: -1722.9069,
    cy: 1092.671,
    r: 5.5349,
    gradientTransform: "matrix(-0.6133 -0.7899 0.3735 -0.2901 -1452.113 -1026.2118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016055701712927022050000008170924227494551457_)"
    },
    d: "M14.6,18c-0.6-0.6-1.6-1.8-2.3-1.9 c-1,0-1.6,1.3-1.2,2.2c0.2,0.6,1,1,1.4,1.5c0.7,1.4,2.2,2.4,2.7,0.3c0,0.1,0,0.1,0,0.1C15.2,19.7,15.2,18.4,14.6,18z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000095324019930920976320000010672563125653359265_",
    cx: -81.6266,
    cy: -317.5939,
    r: 2.5628,
    gradientTransform: "matrix(0.7355 0.6001 0.3617 -0.4397 187.7103 -73.0337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095324019930920976320000010672563125653359265_)"
    },
    d: "M14.4,18.7c-0.1-1.2-1-2.1-2-2.4 C8.5,16.9,14.3,22,14.4,18.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000118391836948123944970000017020547237144262805_",
    cx: -392.0578,
    cy: 631.238,
    r: 0.1095,
    gradientTransform: "matrix(0.7504 -0.661 0.3187 0.362 114.558 -473.7133)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5294,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118391836948123944970000017020547237144262805_)"
    },
    d: "M21.5,13.9L21.5,13.9 C21.5,13.9,21.5,13.9,21.5,13.9C21.5,13.9,21.5,13.9,21.5,13.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114770320890755426630000008510645419760442555_",
    cx: -471.3978,
    cy: 798.9933,
    r: 7.0901,
    gradientTransform: "matrix(0.6674 -0.7447 0.3603 0.3229 46.4621 -590.8923)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3922,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6157,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114770320890755426630000008510645419760442555_)"
    },
    d: "M21.5,13.9c-2.8-0.2-5.6,2.9-6,5.4 c-0.3,3.1,2.5,0.4,3.1-1c0.7-1.3,2.3-3.5,3.4-1.8c0.1,0,0.3-0.1,0.4-0.2h0C22.4,15.3,22.3,14.4,21.5,13.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000071519128014631134370000006342048906994468018_",
    cx: -508.2849,
    cy: 1471.4119,
    r: 3.8656,
    gradientTransform: "matrix(0.6275 -0.7786 0.2663 0.2145 -52.665 -692.8475)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071519128014631134370000006342048906994468018_)"
    },
    d: "M20.1,16.8c-1,1-1.5,2.5-2.4,3.4 c0,0.4,0.1,0.9,0.4,0.3l0,0c1.1-1.5,2.4-2.7,3-4.3C20.7,16.4,20.3,16.5,20.1,16.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000028302668992430878170000010120404584123508640_",
    cx: 496.3898,
    cy: 2788.4417,
    r: 5.3373,
    gradientTransform: "matrix(0.6618 -0.7497 -0.1973 -0.1742 239.7536 873.4236)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007644461,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    style: {
      stopColor: "#FF6262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    style: {
      stopColor: "#FF5B5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7945,
    style: {
      stopColor: "#FF5052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    style: {
      stopColor: "#FF3F43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    style: {
      stopColor: "#FF2930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028302668992430878170000010120404584123508640_)"
    },
    d: "M21.2,13.8c-1.9-0.4-4.1,2-4.6,2.7 c-0.5,0.7-0.9,1.4-1,2.3c0-0.1-0.1-0.6-0.1-0.8c-0.3,0.5-0.5,0.7-0.5,0.7l0,0l0,0.5c1.5,0.5,2.4-2.7,3.7-3.3 C19.6,14.8,21,14.8,21.2,13.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000056420654923276531950000014435234688911232393_",
    cx: 498.4976,
    cy: 2779.2939,
    r: 0.04243104,
    gradientTransform: "matrix(0.6618 -0.7497 -0.1973 -0.1742 234.111 876.6367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007644461,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    style: {
      stopColor: "#FF6262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    style: {
      stopColor: "#FF5B5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7945,
    style: {
      stopColor: "#FF5052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    style: {
      stopColor: "#FF3F43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    style: {
      stopColor: "#FF2930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056420654923276531950000014435234688911232393_)"
    },
    d: "M15.7,18.8L15.7,18.8L15.7,18.8 C15.7,18.8,15.7,18.8,15.7,18.8C15.7,18.8,15.7,18.8,15.7,18.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000029004348272508312620000003187776537418889123_",
    cx: -444.9663,
    cy: 166.7075,
    r: 3.5194,
    gradientTransform: "matrix(0.7093 -0.7049 0.5988 0.6024 234.7061 -398.8714)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9059,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029004348272508312620000003187776537418889123_)"
    },
    d: "M21.2,13.8c-0.6-0.2-1.3-0.2-1.8,0.2 c0.2,0.8,0.4,1.8,0.7,2.5c0.5-0.6,1.6-0.8,1.9,0.1C23,15.9,22.2,14.1,21.2,13.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000168092732783507925880000012830097761248842895_",
    cx: -559.0443,
    cy: 594.8234,
    r: 5.7294,
    gradientTransform: "matrix(0.5718 -0.8204 0.5293 0.3689 22.1121 -661.4358)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168092732783507925880000012830097761248842895_)"
    },
    d: "M16.3,17.6c-0.1-0.1-0.1-0.3-0.1-0.5 c-0.1,0.2-0.2,0.4-0.3,0.6l0,0c-0.1,0.3-0.2,0.6-0.2,1c0-0.1-0.1-0.6-0.1-0.8c-0.3,0.5-0.5,0.7-0.5,0.7l0,0l0.1,1.6 c0-0.3,0.1-0.6,0.4-0.8c-0.8,2.3,2,1.2,2.5-0.2C17.3,18.9,16.7,18.3,16.3,17.6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057870290864330942340000001922470808790475906_",
    cx: -561.6898,
    cy: 594.6669,
    r: 0.08120736,
    gradientTransform: "matrix(0.5718 -0.8204 0.5293 0.3689 22.1121 -661.4358)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057870290864330942340000001922470808790475906_)"
    },
    d: "M15.7,18.8 C15.7,18.8,15.7,18.8,15.7,18.8C15.7,18.8,15.7,18.8,15.7,18.8L15.7,18.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000092419767371692981500000009788243517401570967_",
    cx: -925.0695,
    cy: 1235.7487,
    r: 7.0054,
    gradientTransform: "matrix(0.1521 -0.9884 0.4903 7.536472e-02 -444.4651 -984.7866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092419767371692981500000009788243517401570967_)"
    },
    d: "M20.3,22.4c0.2-0.2,0.4-0.4,0.6-0.6 v-0.3c-0.3,0.2-0.6,0.4-0.9,0.4l0,0c-0.4,0.1-1.1-0.1-1.5,0.1c-0.3,0.2-1.2,1.9-0.4,2.1C19.3,24.2,19.7,23,20.3,22.4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138543075315866038220000014272899466469305787_",
    cx: -923.3906,
    cy: 1235.4298,
    r: 5.4862,
    gradientTransform: "matrix(0.1521 -0.9884 0.4903 7.536472e-02 -444.4651 -984.7866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138543075315866038220000014272899466469305787_)"
    },
    d: "M20.9,20.7v-0.3 c-0.4,0.5-1.3,0.7-2.3,0.7C18.5,22,20.5,21.3,20.9,20.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000122685299644705971800000012422381839073259151_",
    cx: -899.7336,
    cy: 1049.9353,
    r: 5.8822,
    gradientTransform: "matrix(0.2003 -0.9797 0.5352 0.1095 -360.739 -976.9322)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122685299644705971800000012422381839073259151_)"
    },
    d: "M22.1,17.9c-0.4,0.6-0.7,1.9-1.2,2.5 v0.3c0.3-0.3,0.8-0.8,0.8-1.4h0c0.1,0.8-0.2,1.6-0.8,2.1v0.3c0.8-0.5,1.3-1.1,2.4-1.2C23.5,19.9,23.1,17.3,22.1,17.9L22.1,17.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021101421907819965670000007516126473193780635_",
    cx: -537.1671,
    cy: 457.7029,
    r: 3.5027,
    gradientTransform: "matrix(0.5821 -0.8131 0.5414 0.3881 87.3693 -592.1945)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3412,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7333,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021101421907819965670000007516126473193780635_)"
    },
    d: "M22.1,17.9c-0.4,0.6-0.7,1.9-1.2,2.5 v0.3c0.3-0.3,0.8-0.8,0.8-1.4h0c0.1,0.8-0.2,1.6-0.8,2.1v0.3c0.8-0.5,1.3-1.1,2.4-1.2C23.5,19.9,23.1,17.3,22.1,17.9L22.1,17.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040534047416764241080000007662319573779185572_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1483,
    y1: -472.3366,
    x2: 21.2619,
    y2: -471.8067,
    gradientTransform: "matrix(1 0 0 1 0 495.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040534047416764241080000007662319573779185572_)"
    },
    d: "M21.6,21.8c-0.9,0.3-1.6,1.7-1.7,2.6 c0.2,0.2,0.3,0.5,0.4,0.8c0.2-0.8,1.3-2.9,1.6-3.4C21.8,21.7,21.7,21.7,21.6,21.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088828744129453999500000003661376457958203264_",
    cx: -999.7685,
    cy: 1572.3623,
    r: 1.7258,
    gradientTransform: "matrix(4.589089e-02 -0.9989 0.4458 2.376493e-02 -639.6965 -1012.0961)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088828744129453999500000003661376457958203264_)"
    },
    d: "M14.6,24.4c0.1,2.4,2,1,1.6-0.8 c0-1.1-0.8-2.2-1.3-0.7l0,0C14.7,23.5,14.6,23.6,14.6,24.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109026986276184681510000001110754132331028113_",
    cx: -1050.2529,
    cy: 1693.5364,
    r: 4.9436,
    gradientTransform: "matrix(0 -1 0.4239 0 -702.1656 -1026.0527)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7137,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109026986276184681510000001110754132331028113_)"
    },
    d: "M14.7,22.9c-0.1,0.2-0.2,0.4-0.2,0.6 c0.1,0.1,0.1,0.2,0,0.3c-0.1-0.4-0.2-0.6-0.4-1.1c0.1,0.7-0.1,2-0.3,2.5c0.8,0.3,1.2,1,2.1,0.7c-0.1,0.2-0.9,0.2-1.1,0.1 c0.5,1.4,2.5,0.5,2.8-0.8c-0.4,0.3-0.6,0.4-1,0.4C18.1,25.4,15.9,19.6,14.7,22.9z"
  }), _ref82, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072991284728237461950000016093785786572007348_",
    cx: -147.6678,
    cy: -549.5109,
    r: 3.2026,
    gradientTransform: "matrix(0.9904 -0.1381 8.505577e-02 0.6059 209.1819 338.6423)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072991284728237461950000016093785786572007348_)"
    },
    d: "M14.8,27.8L14.8,27.8 c0.2,0,0.3-0.1,0.6-0.2c0.3-0.5,3.2,0.1,2.3-0.6c-0.4-0.4-0.5-1.2-0.1-1.9c-0.8,0.7-2.2,0.9-3,0.9C14.9,26.8,15,27.4,14.8,27.8 C14.8,27.9,14.8,27.8,14.8,27.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059287512414258321670000008021815884693549747_",
    cx: -153.7787,
    cy: -643.3663,
    r: 3.767,
    gradientTransform: "matrix(0.9935 -0.1135 4.541864e-02 0.4001 199.509 269.5797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    style: {
      stopColor: "#FF232B",
      stopOpacity: 0.698
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059287512414258321670000008021815884693549747_)"
    },
    d: "M13.8,29.3c0.9,2.4,3.3-1.2,4.7-0.8 c-0.6,0.2-1.1,0.5-1.6,0.8c2.2-0.4,4.3,0.2,3.9-2.8c-2.3,0.8-4.6,1.5-6.9,2C13.8,28.7,13.8,29,13.8,29.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000070804822855574191610000016921596620237389702_",
    cx: -1047.1428,
    cy: 954.4218,
    r: 2.4927,
    gradientTransform: "matrix(0 -1 0.6394 0 -597.9116 -1022.5527)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5451,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070804822855574191610000016921596620237389702_)"
    },
    d: "M14,22.5c-0.3,0.6-1.2,0.9-1.8,0.6 c0,0.5,0.4,1,0.8,1.1c0,0,0,0,0-0.1c0.1,0.2,0.3,0.5,0.5,0.9C13.7,24.3,14,23.1,14,22.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000038412779824095826920000009148963062773733278_",
    cx: -122.7137,
    cy: -679.4178,
    r: 1.797,
    gradientTransform: "matrix(1 0 0 1 135.3 701.2336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5451,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038412779824095826920000009148963062773733278_)"
    },
    d: "M13.8,22.7c0.2-0.2,0.1-0.4,0-0.6 c-1.5,0.1-1.7-0.5-2.4-2.3c0.1,1.6-0.2,2.9,1.4,3.3c0,0,0,0-0.1,0C13.2,23.1,13.6,23,13.8,22.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049220290171155044650000010838641995855803797_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.1634,
    y1: -471.1257,
    x2: 12.8312,
    y2: -471.5123,
    gradientTransform: "matrix(1 0 0 1 0 495.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049220290171155044650000010838641995855803797_)"
    },
    d: "M13,23.4c-0.6-0.2-0.9-0.2-1.2-0.7 c-0.5,1.1,1.3,1.5,1.3,2.6c0.1-0.1,0.2-0.1,0.3-0.1C13.5,24.9,14.2,23.6,13,23.4L13,23.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065759885690546943930000010506111465735637930_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.4284,
    y1: -473.666,
    x2: 12.1067,
    y2: -473.7908,
    gradientTransform: "matrix(1 0 0 1 0 495.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065759885690546943930000010506111465735637930_)"
    },
    d: "M11.6,20.3c-0.1-0.1-0.1-0.1-0.2-0.2 c0,0.1,0,0.2,0.1,0.2h0c-0.5,2.2,2.1,3.8,1.3,1.8C12.3,21.5,11.6,20.8,11.6,20.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008845730783143651970000006299071690321642151_",
    cx: -323.6555,
    cy: -11.6006,
    r: 6.4013,
    gradientTransform: "matrix(0.9202 -0.3914 0.2074 0.4878 330.564 -104.4558)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008845730783143651970000006299071690321642151_)"
    },
    d: "M24.6,16.7c-0.1,0-0.3,0-0.4,0 c-0.2,0.5-0.5,1.5-0.1,2.1c0.5-1.9,2.8-1.3,3.7-3c0.3-0.3,1.2-1.9,1.9-2.6c-0.4,0.1-0.8,0.3-1.2,0.1c-0.8,0.7-1.6,1.4-2.8,1.8 C25.8,15.7,25.5,16.7,24.6,16.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000147180359062361770660000011814919054097679770_",
    cx: -355.4394,
    cy: -48.9163,
    r: 6.8503,
    gradientTransform: "matrix(0.8661 -0.4999 0.4348 0.7532 352.9369 -132.2253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8039,
    style: {
      stopColor: "#818181",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9608,
    style: {
      stopColor: "#818181"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147180359062361770660000011814919054097679770_)"
    },
    d: "M27.8,7.2c0.3,2.7-1.6,5.7-4.5,5.8 c-0.1,5.9,11.6-2.5,4.9-7.9C27.9,5.9,27.8,6.6,27.8,7.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000069364111443273910940000011728318568789015994_",
    cx: -248.9512,
    cy: -297.4398,
    r: 5.4394,
    gradientTransform: "matrix(0.966 -0.2586 0.2289 0.8553 331.6747 198.0647)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8235,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#818181",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069364111443273910940000011728318568789015994_)"
    },
    d: "M28.6,6.5c-0.8-2.3-1.2-2-3.3-2 c3.1,2.3,2.2,6.6-1.8,6.6c-0.1-0.1-0.2,0.3-0.3,0.7l0,0c-0.2,0.8-0.3,1.1-0.1,1.5C26.4,12.8,29.9,10.1,28.6,6.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093889981264098250610000004676776695164807848_",
    cx: -239.7532,
    cy: -528.491,
    r: 2.814,
    gradientTransform: "matrix(1 0 0 1 267.3 531.0337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    style: {
      stopColor: "#818181",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#818181"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093889981264098250610000004676776695164807848_)"
    },
    d: "M26.1,1.2c0.1-0.1,0.2-0.3,0.2-0.4 c-1.2,0.8-2,2.6-0.9,3.7h2.1c0,0,0,0,0.1,0C26.5,3.7,25.7,2.5,26.1,1.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000160887549575702503510000012993255509899478425_",
    cx: -198.3898,
    cy: -647.2927,
    r: 6.1568,
    gradientTransform: "matrix(0.9972 7.447468e-02 -5.764294e-02 0.7747 182.9138 524.3371)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160887549575702503510000012993255509899478425_)"
    },
    d: "M28.4,7.7c0.4,2.8-2.6,4.5-5.1,4.6 c-0.1,0.2-0.1,0.5,0,1C25.9,13.2,29.8,10.7,28.4,7.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000187532345850624520000018023302419767606151_",
    cx: -713.1115,
    cy: 193.3237,
    r: 2.3772,
    fx: -712.7453,
    fy: 191.9548,
    gradientTransform: "matrix(0.2584 -0.966 0.966 0.2584 24.3557 -700.2809)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000187532345850624520000018023302419767606151_)"
    },
    d: "M29,37c-1.8-2-4.8,1-3.4,3 C27.7,41.1,29.5,39.2,29,37z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000106842365408441205640000017597665128372673678_",
    cx: -605.6325,
    cy: 749.0912,
    r: 2.6218,
    fx: -605.0402,
    fy: 747.6451,
    gradientTransform: "matrix(0.3791 -0.9254 0.5272 0.2157 -141.9224 -683.7268)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106842365408441205640000017597665128372673678_)"
    },
    d: "M23.8,35.9c-1.7,1.1-3.3,4.9,0.3,4.1 c0.4-1.2,1.1-3,2.2-3.8C25.9,35.3,24.5,35.4,23.8,35.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031891152892472316830000008063476498527409589_",
    cx: -440.9915,
    cy: 215.7665,
    r: 2.4422,
    fx: -440.2639,
    fy: 214.5056,
    gradientTransform: "matrix(0.4998 -0.8661 0.8661 0.4998 38.1261 -452.9012)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031891152892472316830000008063476498527409589_)"
    },
    d: "M5.5,34.8c-0.6-0.1-1,0.2-1.4,0.7 c-2.2,3-1,4,2.2,2.9C7.6,37.6,7.4,34.7,5.5,34.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163054889683357083920000004649712597479107457_",
    cx: -430.3024,
    cy: 1762.4219,
    r: 2.7319,
    fx: -429.4886,
    fy: 1761.0112,
    gradientTransform: "matrix(0.4997 -0.8662 0.3102 0.1791 -329.7258 -651.5106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163054889683357083920000004649712597479107457_)"
    },
    d: "M4.7,34.8c-1.6-0.2-3.9,2.5-3,3.7 c1-0.8,1.8-3.3,3.4-3.7H4.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016044046093820867300000001745826751536349603_",
    cx: -1456.7017,
    cy: -120.1414,
    r: 0.8735,
    fx: -1456.9633,
    fy: -120.5916,
    gradientTransform: "matrix(-0.5024 -0.8647 1.5039 -0.8695 -527.384 -1330.5092)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016044046093820867300000001745826751536349603_)"
    },
    d: "M22.4,34c0.6,0.9,2.3-0.6,2.4-1.3 C23.8,32.3,22.7,32.9,22.4,34z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002367186425424807820000006089624542668841876_",
    cx: -1632.4569,
    cy: -171.5376,
    r: 0.6191,
    fx: -1632.7014,
    fy: -171.814,
    gradientTransform: "matrix(-0.6625 -0.749 1.3296 -1.1725 -831.4312 -1390.6082)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002367186425424807820000006089624542668841876_)"
    },
    d: "M22.6,33.2c0.1-0.2,0.3-0.4,0.5-0.6 c-0.9-0.5-1.7,0.3-2,1.1C21.6,34.5,22.3,33.9,22.6,33.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000066486586970748553320000009655583045670967447_",
    cx: -163.1463,
    cy: -1827.3971,
    r: 4.7347,
    gradientTransform: "matrix(0.9456 0.3254 -9.327549e-02 0.2724 -6.083 567.0472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5294,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066486586970748553320000009655583045670967447_)"
    },
    d: "M9.8,17.2l1-0.1 c0.1-0.2,0.2-0.4,0.4-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-1.8,0.4-3-0.2-5-0.4c0.3,0.9,1.1,0.9,1.8,1.3C8.3,17.4,9.3,17.2,9.8,17.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000106131624210029722420000006245885950849323923_",
    cx: -80.4048,
    cy: -695.98,
    r: 4.318,
    gradientTransform: "matrix(1 0 0 0.4878 88 358.4949)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106131624210029722420000006245885950849323923_)"
    },
    d: "M8.4,17.3c1.2,0.4,2.1,1.1,2.6,2 c0-0.1,0-0.3,0-0.4c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.3-0.4-0.3-1.1-0.1-1.6C10,17.2,9.1,17.3,8.4,17.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120551841135353979930000009066645338451433148_",
    cx: -189.4065,
    cy: -1182.1301,
    r: 4.964,
    gradientTransform: "matrix(0.9166 0.3998 -0.2953 0.6768 -165.672 890.8795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    style: {
      stopColor: "#FF6464"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120551841135353979930000009066645338451433148_)"
    },
    d: "M5.7,15.8c-0.1,0-0.2-0.1-0.3-0.1 c0.8,2.4,2.4,2.1,4.5,2.6c-0.2-0.2-2.3-1.4-2.3-1.8C7.4,15.6,6,15.9,5.7,15.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097498652005491810070000005602369789905114029_",
    cx: -374.0531,
    cy: 369.9133,
    r: 5.8632,
    gradientTransform: "matrix(0.651 -0.7591 0.558 0.4787 44.7859 -434.1978)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8392,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097498652005491810070000005602369789905114029_)"
    },
    d: "M11.3,26.1c0-0.3,0-0.6-0.1-0.9 c-0.7,1.5-1.9,2.9-2.8,4.3c0.8,0.6,1.4,1,0.9,2C11.1,29.7,11.7,28.6,11.3,26.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000063603480411980722180000010026057910034084755_",
    cx: -465.6937,
    cy: 402.0116,
    r: 1.8694,
    gradientTransform: "matrix(0.5002 -0.8659 0.7091 0.4088 -46.0473 -533.4579)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063603480411980722180000010026057910034084755_)"
    },
    d: "M4.9,33.5c0.9-0.2,1.9-0.1,2.7,0.6 C7.6,31.4,6.6,32.6,4.9,33.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000045587639427792761660000013104329069554787724_",
    cx: 724.7438,
    cy: 1675.7167,
    r: 2.1875,
    fx: 723.7305,
    fy: 1675.7017,
    gradientTransform: "matrix(0.4178 -0.9085 -0.3989 -0.1835 375.165 993.1047)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2793,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045587639427792761660000013104329069554787724_)"
    },
    d: "M10.3,25.7c-0.2-0.2-0.5,0-1,0.5 c-1.1,1.6-1,2.3-1.2,4C8.2,31.6,11.3,26.4,10.3,25.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000149352019872850275860000012013165851194324652_",
    cx: 732.3021,
    cy: 1458.1038,
    r: 1.82,
    fx: 731.4119,
    fy: 1458.0981,
    gradientTransform: "matrix(0.3942 -0.919 -0.4655 -0.1997 400.701 985.608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8865,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149352019872850275860000012013165851194324652_)"
    },
    d: "M11.2,20.6c0-0.1-0.1,0-0.1,0 c-1.4,0.1-1.3,2.2-0.9,3.6C10.7,25.1,11.5,20.9,11.2,20.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000099631478691259287710000009828807166424558464_",
    cx: -309.7331,
    cy: -1132.6458,
    r: 4.0021,
    gradientTransform: "matrix(0.9441 0.3297 -0.2589 0.7407 24.7087 969.4066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#FF232B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9608,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099631478691259287710000009828807166424558464_)"
    },
    d: "M26.3,30.8c0.7-0.3,1.3-0.6,1.3-0.8 c-0.1-0.5-2-1-3.1-1.9c-1.8-1.5-2.9,0.3-2.4,1.6C23.5,31,24,31.9,26.3,30.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000052094189856075964680000007982633665933681801_",
    cx: -877.9319,
    cy: 1483.4318,
    r: 11.6212,
    gradientTransform: "matrix(0.1588 -0.9873 0.3777 8.682983e-02 -385.887 -971.1646)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052094189856075964680000007982633665933681801_)"
    },
    d: "M33,18.3c-2-2.3-2.8,2.6-3,4.9 c-0.3,3.8,0.4,3.5,0.4,4.5c0,1-1.3,3.1,0,3.2c-0.4-1.3,1.2-3.2,1.5-3.6C33.1,25.5,34.8,20.1,33,18.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000066500475472007211340000015193013247553268148_",
    cx: -325.4102,
    cy: 66.6898,
    r: 12.2132,
    gradientTransform: "matrix(0.8054 -0.5928 0.4027 0.5472 259.5252 -203.3958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7725,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066500475472007211340000015193013247553268148_)"
    },
    d: "M35.3,19.8c-1.1-1.2-1.5-1.4-2.2-2.7 c-0.8,0.2,0.2-1-1.6,0.3c-0.8,0.6-1.8,3.4-1.3,6.7c0.4,2.4,0.2,4.3-0.1,5.4c-0.1,0.7-0.3,2.4,1.6,0.9c0.6-0.4,1-1.2,1.3-2.7 c0.4-1.2,0,1.7,0.2,1.6C36,27.2,38.2,22.6,35.3,19.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000158022822545931863350000007263882305688822967_",
    cx: -1142.7318,
    cy: -1787.5758,
    r: 6.3972,
    gradientTransform: "matrix(6.597340e-02 0.9978 -0.7339 4.868964e-02 -1204.3835 1249.9635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8314,
    style: {
      stopColor: "#FF232B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158022822545931863350000007263882305688822967_)"
    },
    d: "M36.4,20.9c-0.3-0.5-0.5-0.5-1.1-1 c-1-1.1-1.3-1.5-2.3-2.8c3.8,7.8,2,5.3,0.3,12.2c0.8-0.6,2.6-2.3,3.1-3.7C37,24.3,37.2,22,36.4,20.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000056414664722571438800000002755766643105908150_",
    cx: 39.0248,
    cy: 300.2387,
    r: 1.3339,
    fx: 39.2923,
    fy: 299.2381,
    gradientTransform: "matrix(1 0 0 -1 0 334.3086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056414664722571438800000002755766643105908150_)"
    },
    d: "M40,33.8c0-0.1-0.1-0.3,0-0.4 c0-0.2-0.1-0.4-0.2-0.9c-1-0.1-1.9,1-1.9,2c0,0.8,1.5,1,1.9,0.5C40.1,34.8,40,34.1,40,33.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000060708633898716578600000010368866863652889226_",
    cx: 41.0123,
    cy: 300.0358,
    r: 1.6352,
    fx: 40.6837,
    fy: 298.8093,
    gradientTransform: "matrix(1 0 0 -1 0 334.3086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1647,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060708633898716578600000010368866863652889226_)"
    },
    d: "M42.1,34.5c-0.2-1.1-1.2-1.9-2.3-2 c0.1,0.4,0.2,0.7,0.2,0.9h0c0.2,1.2,0.7,2.8,2.2,1.5C42.2,34.7,42.2,34.6,42.1,34.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021816153147342941260000017356320218899358654_",
    cx: 333.2349,
    cy: 1056.4247,
    r: 3.1839,
    fx: 332.7646,
    fy: 1054.6764,
    gradientTransform: "matrix(0.8508 -0.5255 -0.3232 -0.5233 83.3924 763.6793)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9474,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0.1213
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021816153147342941260000017356320218899358654_)"
    },
    d: "M28.4,34.4c-1.1-1.8-3.3-0.7-4.4,0 c0.8-0.3,2.4,0.3,3.7,0.3C28.6,35.2,28.9,35.1,28.4,34.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163767500512034234900000015231843889599148972_",
    cx: -1921.3733,
    cy: -644.7686,
    r: 2.8356,
    fx: -1923.3871,
    fy: -644.5663,
    gradientTransform: "matrix(-0.995 9.989935e-02 -0.2208 -2.2033 -2014.6986 -1211.0768)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5268,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163767500512034234900000015231843889599148972_)"
    },
    d: "M37.6,23.7c0,0.2,0.3,0.5,0.8,0.2 c1.2-0.8,2-4.1,2.1-5.1h0c0-0.5-0.2-1-0.3-1.5c-0.1,3.2-1.3,3.1-3.6-0.4C36.6,17.1,37.5,21.8,37.6,23.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000005236243927816201650000010632246744105792691_",
    cx: -380.6078,
    cy: -499.0057,
    r: 1.1346,
    fx: -379.79,
    fy: -499.3452,
    gradientTransform: "matrix(0.9236 -0.3835 0.8772 2.1115 828.474 925.8228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1608,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0.5098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005236243927816201650000010632246744105792691_)"
    },
    d: "M37.3,15.4c0.1,1.3,2.6,8.3,3,5.2 c0.3-1.5,0.3-2.5,0-3c-0.6-1.4-2.3-1.4-3.1-2.5L37.3,15.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000134211543415472338520000009276895117111718799_",
    cx: -1540.8745,
    cy: -2386.0745,
    r: 6.4262,
    gradientTransform: "matrix(-0.4508 0.8926 -0.3533 -0.1786 -1500.2291 969.4682)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8314,
    style: {
      stopColor: "#FF232B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134211543415472338520000009276895117111718799_)"
    },
    d: "M38.8,22.7c-1.5,1.9-0.5,1.8,0.4,0.3 c0.6-1,1.3-2.8,1.2-4.5C39.8,19.6,39.3,21.8,38.8,22.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115503992495104249170000011933595148282618783_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.9762,
    y1: -473.2217,
    x2: 40.2525,
    y2: -472.761,
    gradientTransform: "matrix(1 0 0 1 0 495.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5451,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    style: {
      stopColor: "#990000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115503992495104249170000011933595148282618783_)"
    },
    d: "M40.5,18.8c-0.2,4-1,2.8,0.4,7.3l0,0 c0-0.3,0.6-1.7,0.8-2.3C41.8,23.8,40.5,18.8,40.5,18.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000061443241133833565670000010053133136116709520_",
    cx: -802.2002,
    cy: -1825.7874,
    r: 2.3167,
    fx: -801.8143,
    fy: -1827.2358,
    gradientTransform: "matrix(0.2575 -0.9663 -0.5914 -0.1657 -833.9854 -1048.7654)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5294,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061443241133833565670000010053133136116709520_)"
    },
    d: "M38.6,30.8c1.8,0.6,3.3-3.1,1.5-3.9 L38.6,30.8C38.6,30.8,38.6,30.8,38.6,30.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000131339072440543998570000009733895147756196750_",
    cx: -521.5813,
    cy: -1567.7135,
    r: 3.7583,
    fx: -519.6315,
    fy: -1566.0251,
    gradientTransform: "matrix(0.756 0.6546 -0.3746 0.4325 -155.8331 1035.3937)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131339072440543998570000009733895147756196750_)"
    },
    d: "M37.1,14.9c0,0,2.7,0.9,3.2,3 c0.1-2.1-1.5-4.7-3.7-5C36.7,13.1,37,14.5,37.1,14.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000051378722886129932790000008781186532843982771_",
    cx: -477.2198,
    cy: -1630.3843,
    r: 4.9672,
    gradientTransform: "matrix(0.7759 0.6309 -0.3438 0.4228 -158.0909 1006.8269)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7804,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051378722886129932790000008781186532843982771_)"
    },
    d: "M36.6,18.8c-0.3-1.1,0.3-1.9-0.8-2.9 c-1.1-1.1-3.4-3.6-6-4.3c0,0.1,1.1,1.2,1,1.2l0.1,0.4c1,1,1.9,2.1,2.9,3.1l2.2,2.9C36.3,19.4,36.5,19.1,36.6,18.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000111871290411248650290000010281327127125449879_",
    cx: -289.3686,
    cy: -529.3078,
    r: 3.4445,
    fx: -288.3713,
    fy: -529.4859,
    gradientTransform: "matrix(0.9844 -0.1758 0.2854 1.5977 468.1245 809.3154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111871290411248650290000010281327127125449879_)"
    },
    d: "M34.4,13c0.5,1,0.8,1.3,1.6,1.9 c2.3-3.3-2-4-3.6-4.7C33.1,10.8,34.1,12.3,34.4,13z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116921751109440057000000005491709707229056695_",
    cx: -258.6786,
    cy: -903.1936,
    r: 3.4285,
    gradientTransform: "matrix(0.966 0.2584 -0.1979 0.7393 102.1422 747.9479)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    style: {
      stopColor: "#990000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116921751109440057000000005491709707229056695_)"
    },
    d: "M31.9,11.8c0.1,0.1,0.2,0.2,0.3,0.4 c-0.1-0.1-0.1-0.1-0.2-0.1c0.2,0.3,0.5,0.8,0.7,1.1c-0.6-1.4-1.1-2.7-2.3-3.5c0,0.3-0.1,0.5-0.1,0.8 C30.9,10.9,31.4,11.3,31.9,11.8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078744798047090630850000003276999067668810643_",
    cx: -263.9033,
    cy: -905.0434,
    r: 3.2154,
    gradientTransform: "matrix(0.966 0.2584 -0.1979 0.7393 102.1422 747.9479)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    style: {
      stopColor: "#990000",
      stopOpacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#990000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078744798047090630850000003276999067668810643_)"
    },
    d: "M26.3,8.3C26.3,8.3,26.3,8.2,26.3,8.3 c-1.4-0.2-2.5,0.8-3.5,1.5c0.8-0.5,1.6-0.7,2.7-0.8l0,0c0.1,0,1.2,0,1.3,0C26.9,8.8,27,8.6,27,8.3C26.5,8.2,26.4,8.2,26.3,8.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013163245366338364520000000665194516393747129_",
    cx: -431.2606,
    cy: 355.8357,
    r: 6.4986,
    gradientTransform: "matrix(0.7071 -0.7071 0.539 0.539 123.969 -486.7573)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8039,
    style: {
      stopColor: "#818181",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9608,
    style: {
      stopColor: "#818181"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013163245366338364520000000665194516393747129_)"
    },
    d: "M6,10.2c-1.5,3.4,1.3,6.6,4.9,5.7 c-0.3-0.5-0.5-1.1-0.5-1.7c-4.4,0.3-4-2.7-3.4-6.7C6.5,9,6.4,9.3,6,10.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000040561978966335235180000006884786935130321342_",
    cx: -526.4325,
    cy: -1098.2101,
    r: 4.4116,
    gradientTransform: "matrix(0.5636 0.8261 -1.3855 0.9465 -1211.6748 1482.9178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8235,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#818181",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040561978966335235180000006884786935130321342_)"
    },
    d: "M7.8,9.3C8.2,8,8.6,6.1,6.7,6.1 c3.2,1.8-4,8.1,3.6,8.1c0-0.5,0.1-0.8,0.2-1.2C8.4,13.5,7,11.2,7.8,9.3z"
  }), _ref83, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150076748900492054030000017111403001371690673_",
    cx: -319.0952,
    cy: -212.5002,
    r: 5.4216,
    gradientTransform: "matrix(0.9949 -0.1006 3.517038e-02 0.3488 361.3256 48.4948)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7647,
    style: {
      stopColor: "#FF232B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7725,
    style: {
      stopColor: "#FF232B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150076748900492054030000017111403001371690673_)"
    },
    d: "M35.6,7.9c2-0.1,3.8-0.9,5.9-1.4 c-1.8,2-6.2,2.3-8.8,1.9c-1.7-0.3-1.4-1.2-0.3-1.4c1.1-0.3,2.4,0.3,3.4,0.6L35.6,7.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097468704589375636980000016684226516659995327_",
    cx: -413.5257,
    cy: -998.3326,
    r: 5.8079,
    gradientTransform: "matrix(0.8963 0.4434 -0.3473 0.702 66.3798 891.9531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3922,
    style: {
      stopColor: "#352B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#352B2B",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097468704589375636980000016684226516659995327_)"
    },
    d: "M44,9.6C43.8,9,43.5,8.5,43.3,8h0 c0.7,1.2,1,1.6,1.2,2.7c0.1,0,0.1,0,0.2,0c-0.3-3.9-2.3-5-5.6-3.4c-0.3,0.2-2.8,0.4-2.3,1c0.3,0.2,1.2,0.1,2.8,0.2 c0.8,1.6,3,1.6,4.1,2.8c-0.2-0.6-0.3-1.1-1-1.9c1.1,0.5,1.1,1.7,1.5,2.5C44.2,10.9,44.2,10.2,44,9.6z"
  }), _ref84, _ref85, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000036971828474519182810000001269550095978560188_",
    cx: -171.1111,
    cy: -613.4823,
    r: 2.7556,
    gradientTransform: "matrix(0.9919 -0.1273 0.102 0.7979 252.1315 496.7794)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E50000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#E60505",
      stopOpacity: 0.1343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    style: {
      stopColor: "#EA1212",
      stopOpacity: 0.2824
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4372,
    style: {
      stopColor: "#EF2828",
      stopOpacity: 0.4366
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5007,
    style: {
      stopColor: "#F23333",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7474,
    style: {
      stopColor: "#F94D4D",
      stopOpacity: 0.7471
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036971828474519182810000001269550095978560188_)"
    },
    d: "M19.8,30.1c-0.7,0.1-1.4-0.1-1.6-0.1 l0.1,0.4c1.5,0.2,2.5,0.8,2.9-0.9C21.2,29.5,20.5,30,19.8,30.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093857734188131465570000011925337101326425498_",
    cx: -149.8123,
    cy: -682.3432,
    r: 2.1117,
    gradientTransform: "matrix(0.9926 -0.1212 3.013916e-02 0.2536 186.5025 186.3508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3209,
    style: {
      stopColor: "#FF152F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4884,
    style: {
      stopColor: "#FF2439",
      stopOpacity: 0.7534
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#FF4A52",
      stopOpacity: 0.2838
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6464",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093857734188131465570000011925337101326425498_)"
    },
    d: "M17.4,31.2c-0.5,0.2-0.7,0.4-0.4,0.7 c0.1,0,1.9-0.5,2-0.5C18.7,31,17.9,30.9,17.4,31.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000106133454003873449800000016054588078195628432_",
    cx: 140.0022,
    cy: 1427.1805,
    r: 4.7247,
    gradientTransform: "matrix(0.9548 -0.2972 -0.1055 -0.3389 33.0708 536.2852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FF6464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#FF6060"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6411,
    style: {
      stopColor: "#FF5355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    style: {
      stopColor: "#FF3E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF232B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106133454003873449800000016054588078195628432_)"
    },
    d: "M18.9,10.2c-1.9-0.2-3.7,0.1-5.4,1.6 c-0.4,0.7-0.2,1.1,0.8,1.1C16,12.9,19.4,11.9,18.9,10.2z"
  }), _ref86))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtLogo);
export default __webpack_public_path__ + "static/media/etLogo.bd43c9c7587bf113c6dcd354a8dd791c.svg";
export { ForwardRef as ReactComponent };